import { Icon } from "@outschool/backpack";
import {
  faBook,
  faCalculatorAlt,
  faGlobe,
  faHandshake,
  faLanguage,
  faLaptopCode,
  faMusic,
  faPencil,
  faPencilPaintbrush,
  faPuzzlePiece,
  faSalad,
  faSeedling,
  faVial,
  fasStar,
} from "@outschool/icons";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

const subjectIcons = {
  Arts: faPencilPaintbrush,
  "Arts and Crafts": faPencilPaintbrush,
  "Coding & Tech": faLaptopCode,
  English: faBook,
  "Early Education": faSeedling,
  Fitness: faSalad,
  "Games & Hobbies": faPuzzlePiece,
  "Health & Wellness": faSalad,
  Languages: faLanguage,
  "Learner Favorites": fasStar,
  "Life Skills": faHandshake,
  Math: faCalculatorAlt,
  Music: faMusic,
  STEM: faVial,
  "Science & Nature": faVial,
  History: faGlobe,
  "Social Studies": faGlobe,
  "Test Prep": faPencil,
  "World Languages": faLanguage,
};

function isValidSubject(
  subjectName: any,
): subjectName is keyof typeof subjectIcons {
  return subjectIcons.hasOwnProperty(subjectName);
}

export default function SubjectIcon({ subjectName }: { subjectName: string }) {
  if (isValidSubject(subjectName)) {
    return <Icon fixedWidth icon={subjectIcons[subjectName]} />;
  }
  return null;
}
